import API from 'js/lib/api';
import redirect from 'js/lib/coursera.redirect';

export const initiateLoginFlow = async (id: string, returnTo?: string) => {
  const searchParams = new URLSearchParams();
  searchParams.append('action', 'initiateLoginFlow');
  searchParams.append('id', id);
  searchParams.append('returnTo', returnTo || redirect.getPathname() + redirect.getQueryParams());
  window.location = await API('/api/thirdPartyOrganizations.v1').post(`?${searchParams.toString()}`);
};
